module.exports = __webpack_public_path__ + "static/media/wordmark.f684ba09.svg";